import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiVersion, ApiService } from 'src/app/services/api.service';
import { TurmaModel } from '../models/turmas.model';

@Injectable()
export class TurmaService {
    constructor(private http: HttpClient, private apiService: ApiService) {}

    getTurmas({ hashPeriodo, hashEscola, hashSerie }): Observable<TurmaModel[]> {
        return this.http.get<TurmaModel[]>(
            `${this.apiService.getUrl()}/${ApiVersion}/turmas/${hashPeriodo}/${hashEscola}/${hashSerie}`
        );
    }
}
